import React from 'react';
import classes from './ClassesHeader.module.css';

const LanguageList = ({children}) => {
    return (
        <li className={classes.LangList_item}>{children}</li>
    );
};

export default LanguageList;